import React, { useState } from 'react'
import { TextField } from '@material-ui/core'
import { DatePicker, LocalizationProvider } from '@material-ui/pickers'
import MomentUtils from '@material-ui/pickers/adapter/moment'

const DatePickerWrapper = ({ ...overrides }) => {
  const { helperText, variant, ...datePickerProps } = overrides
  const datePickerConfig = {
    ...datePickerProps,
  }

  const [selectedDate, setSelectedDate] = useState(new Date())

  return (
    <LocalizationProvider dateAdapter={MomentUtils}>
      <DatePicker
        format="ddd, MMM DD, YYYY"
        onChange={setSelectedDate}
        value={selectedDate}
        {...datePickerConfig}
        renderInput={props => (
          <TextField fullWidth required variant={variant} {...props} helperText={helperText} />
        )}
      />
    </LocalizationProvider>
  )
}

export default DatePickerWrapper
